import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import Navigation from './Navigation';

const Layout = ({ children }) => {
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-gray-50">
      {user && <Navigation />}
      <main className={user ? 'pt-16' : ''}>
        {children}
      </main>
    </div>
  );
};

export default Layout;